import deactivateCharm from '../actions/deactivateCharm';
import { mutator } from 'satcheljs';
import { getStore } from '../store/store';
mutator(deactivateCharm, function (actionMessage) {
    var charm = actionMessage.charm;
    var store = getStore();
    if (store.activeCharm === charm) {
        store.activeCharm = null;
    }
});
//# sourceMappingURL=deactivateCharm.js.map